import { useMemo } from 'react';
import styled from 'styled-components';
import AnimationCanvas, { Scene } from './AnimationCanvas';
import { Palette } from './helpers';
import { useServicePalette } from './palette';

/* Positioned so the absolutely-placed canvas fills the card body rather than the whole card. */
const Frame = styled.div`
    position: relative;
    flex: 1;
    width: 100%;
    min-height: 0;
`;

type ServiceAnimationProps = {
    build: (palette: Palette) => Scene;
    interactive?: boolean;
};

export default function ServiceAnimation({ build, interactive }: ServiceAnimationProps) {
    const palette = useServicePalette();
    const scene = useMemo(() => build(palette), [build, palette]);
    return (
        <Frame>
            <AnimationCanvas scene={scene} interactive={interactive} />
        </Frame>
    );
}
